import React from 'react';
import { Stack, Text } from '@fluentui/react';
import { PrimaryButton, DefaultButton } from '@fluentui/react';
import { useQuery } from '../shared/UrlUtilities';
import { CustomActionSeverityTypes } from '../../services/customActionService';

// Props:
// - title: string
// - message: string (error message or descriptive text)
// - severity: 'info' | 'warn' | 'prevent'
// - onOk: () => void
// - onCancel: () => void: () => void

// eslint-disable-next-line prettier/prettier
export default function CustomActionFailure({}) {
    const query = useQuery();
    const severityParam = query.get('severity');
    const titleParam = query.get('title');
    const messageParam = query.get('errorMessage');

    const severity = severityParam ? severityParam : CustomActionSeverityTypes.Warn;
    const title = titleParam ? (titleParam as string) : '';
    const message = messageParam ? (messageParam as string) : '';

    const disableOk = severity == CustomActionSeverityTypes.Prevent;

    return (
        <Stack
            verticalFill
            styles={{
                root: {
                    height: '100vh',
                    boxSizing: 'border-box',
                    display: 'flex',
                },
            }}
            tokens={{ childrenGap: 16 }}
        >
            {/* Title always visible at top */}
            <Text
                variant="xLarge"
                block
                styles={{ root: { textAlign: 'left', padding: '6px', background: '#f3f2f1' } }}
            >
                {title}
            </Text>

            {/* Message area: scrolls if too long, with a min height */}
            <Stack.Item
                grow
                styles={{
                    root: {
                        padding: '0px 12px',
                        minHeight: '2em',
                        overflowY: 'auto', // only this area scrolls
                    },
                }}
            >
                <Text variant="large" block styles={{ root: { textAlign: 'left' } }}>
                    {message}
                </Text>
            </Stack.Item>

            {/* Buttons always visible at bottom, aligned right */}
            <Stack
                horizontal
                horizontalAlign="end"
                tokens={{ childrenGap: 16 }}
                styles={{ root: { width: '100%', padding: 12 } }}
            >
                {!disableOk && (
                    <DefaultButton
                        text="Proceed"
                        disabled={disableOk}
                        onClick={() => Office.context.ui.messageParent(JSON.stringify({ type: 'DialogOk' }))}
                    />
                )}
                <PrimaryButton
                    text="Return to message"
                    onClick={() => Office.context.ui.messageParent(JSON.stringify({ type: 'DialogCancel' }))}
                />
            </Stack>
        </Stack>
    );
}
